import { Box, Button } from '@mui/material';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import ViewListIcon from '@mui/icons-material/ViewList';
import { Link as RouterLink, Outlet, useMatch, useParams } from 'react-router-dom';
import useIsRegistryAdmin from './useIsRegistryAdmin';

/**
 * Wraps every Research Registry page (dashboard, wizard, detail, and admin), like
 * HartPageWrapper does for Hart: the Analyst Institute logo sits above each page. For admins
 * the same row (top right) links across: Registry Admin on the registry pages, and Registry
 * Dashboard (back to the dashboard) on the admin pages.
 */
const RegistryPageWrapper = () => {
  const { projectId } = useParams();
  const isAdmin = useIsRegistryAdmin();
  // The admin page and its organization create/edit pages all live under registry/admin.
  const onAdminPage = Boolean(useMatch('/projects/:projectId/registry/admin/*'));

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
          flexWrap: 'wrap',
          pb: 2,
          mb: 1,
        }}
      >
        <Box
          component="img"
          src="/static/images/analyst-institute-logo.png"
          alt="Analyst Institute"
          sx={{ display: 'block', height: 32, width: 'auto' }}
        />
        {isAdmin &&
          (onAdminPage ? (
            <Button
              variant="outlined"
              size="small"
              startIcon={<ViewListIcon />}
              component={RouterLink}
              to={`/projects/${projectId}/registry`}
            >
              Registry Dashboard
            </Button>
          ) : (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AdminPanelSettingsIcon />}
              component={RouterLink}
              to={`/projects/${projectId}/registry/admin`}
            >
              Registry Admin
            </Button>
          ))}
      </Box>
      <Outlet />
    </Box>
  );
};

export default RegistryPageWrapper;
